import * as S from '@effect/schema/Schema';
import { ConfigurationSet } from './configurationSet';
export const Condition = S.Struct({
    id: S.Number,
    walls: S.Struct({ count: S.Number, faces: S.optional(S.Array(S.String)) }),
    orientation: S.Union(S.Literal('left'), S.Literal('right'), S.Literal('none')),
    constraints: S.Array(S.Number),
});
export const Constraint = S.Struct({
    id: S.Number,
    walls: S.Number,
    surface: S.optional(S.Struct({ type: S.String })),
});
export const Structure = S.Struct({
    id: S.Number,
    furnitureType: S.String,
    parts: S.Array(S.Struct({
        index: S.String,
        name: S.String,
        productType: S.String,
        isParent: S.Boolean,
        cardinality: S.Array(S.Number),
    })),
});
export const Product = S.Struct({
    guid: S.String,
    name: S.String,
    description: S.String,
    productType: S.String,
    configurableProperties: S.Record({ key: S.String, value: S.String }),
    variants: S.Array(S.Struct({
        canonical_id: S.String,
        name: S.String,
        description: S.optionalWith(S.String, { default: () => '' }),
        product_url: S.String,
        properties: S.Record({ key: S.String, value: S.Unknown }),
        features: S.Array(S.Unknown),
        thumbnail: S.String,
        family: S.Array(S.String),
        availability: S.String,
        discontinued: S.Boolean,
        articles: S.Record({ key: S.String, value: S.Unknown }),
        price: S.Struct({ value: S.Number, currency: S.String }),
    })),
});
export const ConfigurationSpace = S.Struct({
    guid: S.String,
    version: S.Literal('4.0.0'),
    created: S.DateFromString,
    updated: S.DateFromString,
    name: S.String,
    description: S.String,
    locale: S.String,
    type: S.Struct({
        superType: S.Union(S.Null, S.String),
        name: S.String,
    }),
    conditions: S.Array(Condition),
    constraints: S.Array(Constraint),
    structures: S.Array(Structure),
    configurations: S.Array(ConfigurationSet),
    products: S.Array(Product),
});
export const ConfigurationSpaces = S.Array(ConfigurationSpace);
